import {
  CREATE_EXPERT_REVIEW_REQUEST,
  CREATE_EXPERT_REVIEW_SUCCESS,
  CREATE_EXPERT_REVIEW_FAIL,
  FETCH_EXPERT_REVIEWS_FOR_EXPERT_REQUEST,
  FETCH_EXPERT_REVIEWS_FOR_EXPERT_SUCCESS,
  FETCH_EXPERT_REVIEWS_FOR_EXPERT_FAIL,
  FETCH_MY_EXPERT_REVIEWS_REQUEST,
  FETCH_MY_EXPERT_REVIEWS_SUCCESS,
  FETCH_MY_EXPERT_REVIEWS_FAIL,
  RESET_EXPERT_REVIEWS_ERROR,
} from "./expertReviewsTypes";

const initialState = {
  myReviews: [],
  reviewsForExpert: [],
  loadingMyReviews: false,
  loadingForExpert: false,
  loadingCreate: false,
  error: null,
};

export const expertReviewsReducer = (state = initialState, action) => {
  switch (action.type) {
    case CREATE_EXPERT_REVIEW_REQUEST:
      return {
        ...state,
        loadingCreate: true,
        error: null,
      };
    case CREATE_EXPERT_REVIEW_SUCCESS:
      return {
        ...state,
        loadingCreate: false,
        myReviews: [...state.myReviews, action.payload],
      };
    case CREATE_EXPERT_REVIEW_FAIL:
      return {
        ...state,
        loadingCreate: false,
        error: action.payload,
      };

    case FETCH_MY_EXPERT_REVIEWS_REQUEST:
      return {
        ...state,
        loadingMyReviews: true,
        error: null,
      };
    case FETCH_MY_EXPERT_REVIEWS_SUCCESS:
      return {
        ...state,
        loadingMyReviews: false,
        myReviews: Array.isArray(action.payload) ? action.payload : [],
      };
    case FETCH_MY_EXPERT_REVIEWS_FAIL:
      return {
        ...state,
        loadingMyReviews: false,
        error: action.payload,
      };

    case FETCH_EXPERT_REVIEWS_FOR_EXPERT_REQUEST:
      return {
        ...state,
        loadingForExpert: true,
        error: null,
      };
    case FETCH_EXPERT_REVIEWS_FOR_EXPERT_SUCCESS:
      return {
        ...state,
        loadingForExpert: false,
        reviewsForExpert: Array.isArray(action.payload) ? action.payload : [],
      };
    case FETCH_EXPERT_REVIEWS_FOR_EXPERT_FAIL:
      return {
        ...state,
        loadingForExpert: false,
        error: action.payload,
      };

    case RESET_EXPERT_REVIEWS_ERROR:
      return {
        ...state,
        error: null,
      };

    default:
      return state;
  }
};
